import { useDispatch } from "react-redux";

import useAlerts from "../useAlerts";

import useLoading from "../useLoading";

import useApiErrorHandler
    from "../useApiErrorHandler";

import useConfirmModal from "../useConfirmModal";

import {
    setLoading,
    setError,
    updateQuotationCalculation
} from "../../store/slices/sale/quotationSlice";

import QuotationItemService
    from "../../services/sale/QuotationItemService";

export const useQuotationItem = () => {

    const dispatch = useDispatch();

    const { show: showAlert } =
        useAlerts();

    const {
        showLoadingIndicator,
        hideLoadingIndicator
    } = useLoading();

    const { handle } =
        useApiErrorHandler();

    const confirm = useConfirmModal();

    /**
     * ➕ Agregar item
     */
    const addItem = async (
        quotationId: number,
        payload: any
    ) => {

        try {

            showLoadingIndicator();

            dispatch(setLoading(true));

            dispatch(setError(null));

            const response =
                await QuotationItemService
                    .addItem(
                        quotationId,
                        payload
                    );


                    console.log(response);

            const {
                statusCode,
                type,
                title,
                message,
                data
            } = response;

            if (statusCode === 200) {

                dispatch(
                    updateQuotationCalculation(
                        data
                    )
                );

                showAlert(
                    type,
                    title,
                    message
                );

            }

        } catch (error: any) {

            const status =
                error?.response?.data?.statusCode ||
                error?.response?.status;

            if (status === 409 && !payload?.confirmReplaceGlobalDiscount) {

                confirm({

                    title: '¿Agregar descuento manual?',

                    message:
                        error?.response?.data?.message ||
                        'La cotización tiene un descuento global activo. Poner un descuento manual en esta línea lo va a quitar.',

                    icon: 'warning',

                    confirmText: 'Sí, quitar el global',

                    cancelText: 'Cancelar',

                    onConfirm: () =>
                        addItem(
                            quotationId,
                            { ...payload, confirmReplaceGlobalDiscount: true }
                        ),

                });

                return;

            }

            handle(error);

        } finally {

            hideLoadingIndicator();

            dispatch(setLoading(false));

        }

    };

    /**
     * ✏️ Actualizar item
     */
    const updateItem = async (
        quotationId: number,
        itemId: number,
        payload: any
    ) => {

        try {

            showLoadingIndicator();

            dispatch(setLoading(true));

            dispatch(setError(null));

            const response =
                await QuotationItemService
                    .updateItem(
                        quotationId,
                        itemId,
                        payload
                    );

            const {
                statusCode,
                type,
                title,
                message,
                data
            } = response;

            if (statusCode === 200) {

                dispatch(
                    updateQuotationCalculation(
                        data
                    )
                );

                showAlert(
                    type,
                    title,
                    message
                );

            }

        } catch (error: any) {

            const status =
                error?.response?.data?.statusCode ||
                error?.response?.status;

            if (status === 409 && !payload?.confirmReplaceGlobalDiscount) {

                confirm({

                    title: '¿Agregar descuento manual?',

                    message:
                        error?.response?.data?.message ||
                        'La cotización tiene un descuento global activo. Poner un descuento manual en esta línea lo va a quitar.',

                    icon: 'warning',

                    confirmText: 'Sí, quitar el global',

                    cancelText: 'Cancelar',

                    onConfirm: () =>
                        updateItem(
                            quotationId,
                            itemId,
                            { ...payload, confirmReplaceGlobalDiscount: true }
                        ),

                });

                return;

            }

            handle(error);

        } finally {

            hideLoadingIndicator();

            dispatch(setLoading(false));

        }

    };

    /**
     * ❌ Eliminar item
     */
    const deleteItem = async (
        quotationId: number,
        itemId: number
    ) => {

        try {

            showLoadingIndicator();

            dispatch(setLoading(true));

            dispatch(setError(null));

            const response =
                await QuotationItemService
                    .deleteItem(
                        quotationId,
                        itemId
                    );

            const {
                statusCode,
                type,
                title,
                message,
                data
            } = response;

            if (statusCode === 200) {

                dispatch(
                    updateQuotationCalculation(
                        data
                    )
                );

                showAlert(
                    type,
                    title,
                    message
                );

            }

        } catch (error) {

            handle(error);

        } finally {

            hideLoadingIndicator();

            dispatch(setLoading(false));

        }

    };

    return {

        addItem,

        updateItem,

        deleteItem,

    };

};